import { BigNumber } from 'bignumber.js';
import { cloneDeep } from 'lodash';
import { REG_AMT } from '@/utils/validate/regExp';
import { validatePhone } from '@/utils/validate/elementMethod';
import { reactive } from 'vue';
import { setToday } from "@/utils/filter/index";
import { getFormatDate2, getFormatDate1 } from "@/utils/insurance/index";
import Store from "@/utils/localStore/index";
import { first } from 'underscore';
import settlementDialog from '../component/settlement-dialog.vue';
import TraceabilityCodeDialog from "@/components/pay-dialog/TraceabilityCodeDialog.vue";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'sale-drug',
  components: {
    TraceabilityCodeDialog,
    settlementDialog
  },
  props: {
    amount: {
      type: [String, Number],
      default: '',
    },
    recordVersion: { // 订单版本
      type: [String, Number],
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    payType: {},
    orderId: {},
    debtorInfo: {
      type: [Object, null],
      default: {
        name: '',
        phone: '',
      },
    },
    orderno: {
      type: [String, Number],
      default: '',
    },
    // 患者订单id
    userOrderId: {
      type: [String, Number],
      default: 0,
    },
    mdtrtId: {
      type: [String, Number],
      default: '',
    },//就诊ID
    psnNo: {
      type: [String, Number],
      default: '',
    },//人员编号
    settlementObj: {
      type: [Object, null],
      default: () => { }
    },//结算流程数据对象
    prohibitFlag: {
      type: Boolean,
      default: false,
    },
    isHiReg: {
      type: Boolean,
      default: false,
    },//是否医保挂号,用来控制多种支付方式
    // // 是否简化医保支付
    // isSimplify: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data () {
    const amtPass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('实收金额不能为空！'));
      }
      if (!REG_AMT.test(value)) {
        return callback(new Error('请填写正确的金额！'));
      }
      if (value < Number(this.total)) {
        return callback(new Error('实收金额不能小于付款金额！'));
      }
      callback();
    };
    const amtPassMul = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('实收金额不能为空！'));
      }
      if (!REG_AMT.test(value)) {
        return callback(new Error('请填写正确的金额！'));
      }
      callback();
    };
    const amtGroup = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('实收金额不能为空！'));
      }
      if (!REG_AMT.test(value)) {
        return callback(new Error('请填写正确的金额！'));
      }
      if (value > Number(this.total)) {
        return callback(new Error('当前金额不能大于付款金额！'));
      }
      callback();
    };
    const validatePayType = (rule, value, callback) => {
      if (value.length !== 2) {
        return callback(new Error('请选择两种支付方式！'));
      }
      callback();
    };
    return {
      userOrderIds: 0,//患者订单id
      memberMoney: 0, //会员金额
      isShowMemberMoney: false,//是否显示会员金额
      readVisible: false,//读卡弹窗
      innerVisible: false,//医保信息弹窗
      showSettlementDialog: false,//简化医保支付弹窗
      newRecordVersion: '',
      payLabel: '',
      total: '', // 总的应收金额
      visibleSync: false,
      activeName: 'first', // 当前激活的tab
      isAwaitPaying: false, // 是否在等待扫码支付状态
      awaitTime: 60, // 等待时间
      payCode: '', // 支付宝用户支付码或者微信用户支付码
      orderNo: '', // 支付订单的订单id
      payTypeOptions: [],//支付方式
      payNoInsuOptions: [],//支付方式（不含医保支付）
      checkBoxsHistory: [], // checkbox 的历史记录
      wechatPayAmt: 0, // 微信当面付金额
      isNameDisabled: false,
      isPhoneDisabled: false,
      confirmDisable: false,
      createdOrderId: '', // 支付完之后的orderId
      ruleForm1: {
        name: '',
        payType: ['cashAmt'], // 付款方式
        actualAmt: 0, // 实收金额
        changeAmt: 0, // 找零金额
        debtAmt: 0, // 欠费
        cashAmt: 0, // 现金支付
        alipayAmt: 0, // 支付宝支付
        wechatAmt: 0, // 微信支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        otherAmt: 0, // 其他支付
        memberAmt: 0,// 会员支付
        medicalInsurance: 0, // 医保支付
        commercialInsurance: 0, // 商保支付
        medicalIndividual: 0,//医保个账支出
        medicalMutualAid: 0,//医保个账共济支出
        notHiExpenses: 0,//非医保费用
      },
      ruleForm2: {
        name: '',
        payType: [], // 付款方式
        actualAmt: 0, // 实收金额
        changeAmt: 0, // 找零金额
        debtAmt: 0, // 欠费
        cashAmt: 0, // 现金支付
        alipayAmt: 0, // 支付宝支付
        wechatAmt: 0, // 微信支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        otherAmt: 0, // 其他支付
        memberAmt: 0,// 会员支付
        medicalInsurance: 0, // 医保支付
        commercialInsurance: 0, // 商保支付
        firstPay: 0, // 第一个选择的支付方式的金额
        medicalIndividual: 0,//医保个账支出
        medicalMutualAid: 0,//医保个账共济支出
        notHiExpenses: 0,//非医保费用,
        cardNo: '', //社会保障卡号
        cardSn: ''//卡识别码
      },
      ruleForm3: {
        name: '',
        payType: ['cashAmt'], // 付款方式
        actualAmt: 0, // 实收金额
        changeAmt: 0, // 找零金额
        debtAmt: 0, // 欠费
        cashAmt: 0, // 现金支付
        alipayAmt: 0, // 支付宝支付
        wechatAmt: 0, // 微信支付
        posAmt: 0, // 银行卡支付
        remainingAmt: 0, // 余额支付
        otherAmt: 0, // 其他支付
        memberAmt: 0,// 会员支付
        medicalInsurance: 0, // 医保支付
        commercialInsurance: 0, // 商保支付
        debtorsName: '',
        debtorsPhone: '',
        medicalIndividual: 0,//医保个账支出
        medicalMutualAid: 0,//医保个账共济支出
        notHiExpenses: 0,//非医保费用
      },
      rules1: {
        amt: [
          { required: true, message: '请输入金额', trigger: 'blur' },
        ],
        actualAmt: [
          { validator: amtPass, trigger: 'change' },
        ],
        actualAmtMul: [
          { validator: amtPassMul, trigger: 'change' },
        ],
        payType: [
          { type: 'array', required: true, message: '请至少选择一种支付方式', trigger: 'change' },
        ],
      },
      rules2: {
        firstPay: [
          { validator: amtGroup, trigger: 'change' },
        ],
        payType: [
          { validator: validatePayType, trigger: 'change' },
        ],
      },
      rules3: {
        amt: [
          { required: false, message: '请输入金额', trigger: 'blur' },
        ],
        payType: [
          { type: 'array', required: true, message: '请至少选择一种支付方式', trigger: 'change' },
        ],
        actualAmt: [
          { validator: amtGroup, trigger: 'change' },
        ],
        debtorsName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        debtorsPhone: [
          { required: true, validator: validatePhone, trigger: 'change' },
        ],
      },
      insuDrugList: [],//有医保信息的药品列表
      examList: [],//医保检查项目列表
      hiSelectFlag: false,//多种支付是否勾选了医保支付
      medfeeSumamt: '0',//医疗费用总额
      fundPaySumamt: '0',//基金支付总额
      // othPayDesc:"",//其他支付方式
      psnPartAmt: '0',//个账支出总额
      selfPay: 0,//自费金额(除去医保报销以及医保账户的钱)
      acctPay: '',//个人账户支出
      acctMulaidPay: '0',//个人账户共济支付金额
      psnCashPay: '0',//个人现金支出
      setlId: '',//结算id
      form1: {
        mdtrt_cert_type: '',
        mdtrt_cert_no: '',
        card_sn: '',//卡识别码 选社保卡时必传
        psn_cert_type: '',//人员证件类型 选社保卡时必传
        certno: '',//人员证件号码 选社保卡时必传
        psn_name: '',//人员名称
        areaNo: '',//区域信息
      },//获取人员信息需要的参数
      isUploadDetail: false,
      radio: 1,//是否使用个人账户
      readType: 0,//读卡类型 
      active: 0,//步骤条高亮
      registerForm: {
        psn_name: "",
        age: "",
        bir: "",
        phone: "",
        naty: "",
        chronic: "",
        gender: "",
        dept_code: "", //科室编码 A03
        dept_name: "", //内科
        caty: "", //科别 A03
        atddr_no: "", //医生编码 D430111022228
        dr_name: "", //孙玲
        psn_no: "", //人员编号
        mdtrt_cert_type: "01", //就诊凭证类型
        mdtrt_cert_no: "", //就诊凭证编号
        insutype: "", //险种
        doctorId: "", //医生id
        laboratoryId: "", //科室id
        certno: "",
        settingExtendId: "", //挂号要传入的排班id
        scheduleId: "", //获取到的排班id
      },//挂号信息
      registerRules: {
        psn_name: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        certno: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        laboratoryId: [
          { required: true, message: "请选择科室", trigger: "blur" },
        ],
        doctorId: [{ required: true, message: "请选择医生", trigger: "blur" }],
        insutype: [{ required: true, message: "请选择险种", trigger: "blur" }],
        scheduleId: [
          { required: true, message: "请选择挂号时间", trigger: "blur" },
        ],
        dept_name: [
          { required: true, message: "请选择科室", trigger: "blur" },
        ],
        dr_name: [
          { required: true, message: "请选择医生", trigger: "blur" },
        ],
      },
      insuTypeList: [],//险种列表
      opspDiseasesList: [],//慢特病列表
      query: {
        laboratoryId: "",
      },
      laboratoryList: [], //科室列表
      insuDeptList: [], //诊所医保科室列表
      doctorList: [], //医生列表
      schedulingList: [], //排班列表
      visitsInfoUploadForm: {
        diag_code: [],//诊断编码
        // diag_name:[],//诊断名称
        diag_type: '1',//诊断类型
        dise_codg: '',//病种编码
        dise_name: '',//病种名称
        med_type: '11',//医疗类别
      },
      visitsInfoUploadRules: {
        diag_code: [
          { required: true, message: "请输入诊断编码", trigger: "blur" },
        ],
        diag_name: [
          { required: true, message: "请输入诊断名称", trigger: "blur" },
        ],
        diag_type: [
          { required: true, message: "请输入诊断类型", trigger: "blur" },
        ],
        dise_codg: [
          { required: false, message: "请输入病种", trigger: "blur" },
        ],
        dise_name: [
          { required: true, message: "请输入病种名称", trigger: "blur" },
        ],
        med_type: [
          { required: true, message: "请输入医疗类别", trigger: "blur" },
        ],
      },
      medTypeOptions: [
        {
          value: '11',
          label: '普通门诊'
        }, {
          value: '14',
          label: '门诊慢特病'
        }
      ],
      diagTypeOptions: [
        {
          value: '1',
          label: '疾病诊断'
        }, {
          value: '2',
          label: '中医疾诊'
        }, {
          value: '3',
          label: '中医证候'
        }
      ],
      diseaseList: [],//病种列表
      diagTypeList: [],//医保诊断列表
      scheduleString: '',//排班时间字符串
      insutypeLabel: '',//险种名称
      insuDiagString: '',//医保诊断字符串
      jzId: '',//就诊id(挂号成功后返回的)
      jzpsnNo: '',//就诊人员编号(挂号成功后返回的)
      mdtrtIdByProps: '',//就诊id(父组件传过来的)
      psnNoByProps: '',//就诊人员编号(父组件传过来的)
      uploadjzInfoFlag: false,//是否上传了就诊信息
      isElectPay: false,//是否电子凭证支付，而不是读卡
      pCardInfo: {
        card_sn: '',
        card_no: ''
      },//社保卡信息
      traceabilityList: {
        orderItemDrugList: [],
        orderItemDiagnosisDetailList: [],
      }, // 追溯码列表
      keyList: ['orderItemDrugList', 'orderItemDiagnosisDetailList'],
      invRequired: 0, // 有没有开启医保上报
      traceCodeRequired: 0, // 追溯码是否必填
      isOpenTraceCode: 0, // 追溯码是否必填
    };
  },
  filters: {
    // 单位
    unitFilter (val) {
      console.log('val: ', val);
      return `元/${1}`
    },
  },
  methods: {
    handleClick () {
      if (this.$refs[`${this.activeName}-input`]) {
        this.$nextTick(() => {
          this.$refs[`${this.activeName}-input`].$el.querySelector('input').focus();
        });
      }
      if (this.activeName == 'second') {
        if (this.isHiReg) {
          this.ruleForm2.payType.push('medicalInsurance')
          // console.log(this.ruleForm2.payType,'this.ruleForm2.payType');
        }
      }
    },
    payTypeHandle (ruleName) {
      if (this[ruleName].payType.length > 0) {
        this[ruleName].payType.splice(0, 1);
      }
      // this.getMemberMoney()
    },
    choosePayType (e) {
      if (e[1]) {
        this.payLabel = `${e[1]}：`;
      } else {
        this.payLabel = '其他：';
      }
    },
    // 结算流程
    // settlementProcess () {
    //   // console.log(this.orderNo,'orderNo');
    //   this.$api.newInsurance.settlementProcessAPI({
    //     orderNo: this.orderno
    //   }).then(res => {
    //     if (res.data.code == 200 && res.data.data != null) {
    //       this.$emit('update:settlementObj', res.data.data)
    //       console.log('res.data.data: ', res.data.data);
    //     }
    //   })
    // },
    // 多种支付
    payTypeMoreHandle (e) {
      if (e.length < 2) {
        this.checkBoxsHistory = cloneDeep(this.ruleForm2.payType);
      }
      if (e.length > 2) {
        this.ruleForm2.payType = e.splice(0, 1);
        this.checkBoxsHistory = cloneDeep(this.ruleForm2.payType);
      }
      // 如果勾选了医保支付，需要给个标识来显示医保相关的内容
      // console.log(this.ruleForm2.payType,'支付类型数组');
      this.hiSelectFlag = this.ruleForm2.payType.some(item => item == 'medicalInsurance')
      if (this.hiSelectFlag) {
        this.$emit('settlementProcess')
      }
      // 如果isHiReg为true说明是医保挂号，需要把医保支付加进去，不能取消勾选
      // console.log(this.isHiReg,'this.isHiReg 弹窗');
      if (this.isHiReg) {
        if (!this.hiSelectFlag) {
          this.ruleForm2.payType.push('medicalInsurance')
        } else {
          this.ruleForm2.payType.push('medicalInsurance')
          // 数组去重
          // this.ruleForm2.payType = [...new Set(this.ruleForm2.payType)]
        }
      }
      this.ruleForm2.payType = [...new Set(this.ruleForm2.payType)]

      if (!this.$store.state.global.isHiSuccess && this.hiSelectFlag) {
        this.$message({
          type: 'warning',
          message: '未开通医保，无法进行医保支付'
        })
        this.ruleForm2.payType = this.ruleForm2.payType.filter(item => item != 'medicalInsurance')
        return
      }

      // console.log(this.hiSelectFlag,'医保标识');
      // console.log(this.prohibitFlag,'prohibitFlag');
      this.ruleForm2.notHiExpenses = (this.total - this.settlementObj.hiTotalAmount) || 0
      if (this.settlementObj.outpatientVisits != null) {
        this.mdtrtIdByProps = this.settlementObj.outpatientVisits.mdtrtId
        this.psnNoByProps = this.settlementObj.outpatientVisits.psnNo
      }

      if (this.hiSelectFlag && this.prohibitFlag) {
        this.$message({
          type: 'warning',
          message: '未存在匹配成功的医保药品，无法进行医保支付'
        })
        this.ruleForm2.payType = this.ruleForm2.payType.filter(item => item != 'medicalInsurance')
        return
      }
      if (this.hiSelectFlag && this.hasPayType && !this.prohibitFlag) {
        // 数据反显
        if (this.settlementObj.processType == 1) {
          // 跳到上传费用明细那一步
          this.active = 2
          // 医保流程
          // 挂号信息反显
          const { outageRegResponse } = this.settlementObj
          this.registerForm.psn_name = outageRegResponse.psnName
          this.registerForm.age = outageRegResponse.age
          this.registerForm.bir = outageRegResponse.bir
          this.registerForm.certno = outageRegResponse.certno
          this.registerForm.phone = outageRegResponse.phoneNo
          this.registerForm.naty = outageRegResponse.naty
          this.registerForm.chronic = outageRegResponse.chronic
          this.registerForm.gender = outageRegResponse.gender
          this.registerForm.dept_name = outageRegResponse.deptName
          this.registerForm.dr_name = outageRegResponse.drName
          this.scheduleString = outageRegResponse.shiftInformation
          this.insutypeLabel = outageRegResponse.insutypeLabel
          // 就诊信息反显
          const { outpatientVisits } = this.settlementObj
          const { outpatientVisitsDiagnosisList } = this.settlementObj
          this.visitsInfoUploadForm.med_type = outpatientVisits.medType
          this.visitsInfoUploadForm.dise_name = outpatientVisits.diseName || '无'
          this.visitsInfoUploadForm.diag_type = outpatientVisitsDiagnosisList[0].diagType
          let arr = []
          outpatientVisitsDiagnosisList.forEach(item => {
            arr.push(item.diagName)
          })
          // console.log(arr,'arr');
          this.insuDiagString = arr.join(',')
        } else if (this.settlementObj.processType == 2 && this.settlementObj.registeredType == 1) {
          // 补了挂号流程但是没补就诊信息
          // 挂号信息反显
          const { outageRegResponse } = this.settlementObj
          this.registerForm.psn_name = outageRegResponse.psnName
          this.registerForm.age = outageRegResponse.age
          this.registerForm.bir = outageRegResponse.bir
          this.registerForm.certno = outageRegResponse.certno
          this.registerForm.phone = outageRegResponse.phoneNo
          this.registerForm.naty = outageRegResponse.naty
          this.registerForm.chronic = outageRegResponse.chronic
          this.registerForm.gender = outageRegResponse.gender
          this.registerForm.dept_name = outageRegResponse.deptName
          this.registerForm.dr_name = outageRegResponse.drName
          this.scheduleString = outageRegResponse.shiftInformation
          this.insutypeLabel = outageRegResponse.insutypeLabel
        } else if (this.settlementObj.registeredType == 2) {
          // 未挂号
          this.recurrentInfo()
        }
        this.insuDrugList = this.settlementObj.orderItemDrugList || []
        this.examList = this.settlementObj.orderItemExamList || []
        this.getYbDrug()
        // 如果上传了明细就跳到预结算
        if (this.hasUploadDetail) {
          this.active = 3
        }
        this.getFundPaySumamt()
      }
    },
    async confirm () {
      // 判断追溯码是否填写
      // isOpenTraceCode 1 采集按钮显示          traceCodeRequired 1 追溯码必填
      if (this.activeName === 'first' || this.activeName === 'second') {
        if (this.isOpenTraceCode == 1 && this.traceabilityCodeNum != this.traceabilityDrugNum && this.traceCodeRequired == 1) {
          return this.$message.error('追溯码数量与药品数量不一致');
        }
      }

      // if (!this.isPreSettlement) {
      //   this.$message({
      //     message: '请先进行试算',
      //     type: 'warning',
      //   })
      // }
      if (this.activeName == 'second' && !this.hasPayType) {
        this.$message({
          message: '请选择支付方式',
          type: 'warning',
        })
        return
      }
      if (this.activeName == 'second' && this.hiSelectFlag && !this.hasUploadDetail) {
        this.$message({
          message: '请先上传费用明细',
          type: 'warning',
        })
        return
      }
      console.log(this.isPreSettlement, '是否预结算');
      if (this.activeName == 'second' && this.hiSelectFlag && !this.isPreSettlement) {
        this.$message({
          message: '请先进行预结算',
          type: 'warning',
        })
        return
      }
      const req = {
        debtorsName: '',
        debtorsPhone: '',
        cashAmt: 0,
        actualAmt: 0,
        debtAmt: 0,
        alipayAmt: 0,
        wechatAmt: 0,
        posAmt: 0,
        remainingAmt: 0,
        otherAmt: 0,
        medicalInsurance: 0,
        commercialInsurance: 0,
        wechatAppsAmt: 0,
        wechatPayAmt: 0,
        memberAmt: 0,
        id: this.$route.query.id || this.orderId,
        medicalIndividual: 0, //个账支出
        medicalMutualAid: 0,//个人账户共济支付金额
        notHiExpenses: 0,//非医保费用
      };
      if (this.confirmDisable) return;
      this.confirmDisable = true;
      // 如果是直接售药就不要传这个recordVersion参数其他支付方式需要
      if (this.recordVersion) {
        req.recordVersion = this.recordVersion;
      }
      const [type] = this.ruleForm1.payType;
      const [types] = this.ruleForm3.payType;
      if (this.activeName === 'first') {
        // 使用会员支付,实际支付价格大于用户会员总金额提示会员余额不足
        // if (+this.ruleForm1.actualAmt > this.memberMoney && && this.ruleForm1.payType[0] === 'memberAmt') {
        //   return this.$message({
        //     type: "error",
        //     message: "会员余额不足!"
        //   })
        // }

        // req.actualAmt = this.amount; // 实收金额
        if (this.ruleForm1.actualAmt < this.amount && this.payType === 'onePay') {
          req.actualAmt = Number(this.ruleForm1.actualAmt);
        } else {
          req.actualAmt = this.amount;
        }
        if (type === 'cashAmt') {
          if (this.ruleForm1.actualAmt < this.amount && this.payType === 'onePay') {
            req.cashAmt = Number(this.ruleForm1.actualAmt);
          } else {
            req.cashAmt = this.amount;
          }
        } else if (this.ruleForm1.actualAmt < this.amount && this.payType === 'onePay') {
          req[type] = Number(this.ruleForm1.actualAmt);
        } else {
          req[type] = this.amount;
        }
      }
      // 多种支付
      if (this.activeName === 'second') {
        req.actualAmt = this.total;
        req[this.ruleForm2.payType[0]] = this.ruleForm2.firstPay;
        req[this.ruleForm2.payType[1]] = this.selfPay;
        req.medicalIndividual = this.ruleForm2.medicalIndividual //个账支出
        req.medicalMutualAid = this.ruleForm2.medicalMutualAid //个人账户共济支付金额
        req.notHiExpenses = this.ruleForm2.notHiExpenses //个人账户共济支付金额
        // 选择了医保支付并且就诊凭证类型为社保卡时需处理
        console.log(this.isSbCardPay, '是否刷社保卡');
        if (this.hiSelectFlag && this.isSbCardPay) {
          console.log(this.isSbCardPay, '是否刷社保卡');
          const total1 = Number(this.total).toFixed(2)
          const total2 = (this.ruleForm2.medicalIndividual + this.fundPaySumamt).toFixed(2)
          const params = {
            strpCardInfo: this.ruleForm2.cardSn + '|' + this.ruleForm2.cardNo + '|',
            strpPayInfo: total1 + '|' + total2 + '|' + getFormatDate1() + '|'
          }
          const res = await this.$api.newInsurance.socialCardTransactions(params)
          if (res.data.code == 0) {
            // 成功的情况继续完成系统的收费操作
          } else {
            this.$message({
              type: "error",
              message: "社保卡支付失败",
            });
            return
          }
        }
      }
      if (this.activeName === 'third') {
        req.actualAmt = this.total;
        req.debtAmt = this.debtAmt;
        req.debtorsName = this.ruleForm3.debtorsName;
        req.debtorsPhone = this.ruleForm3.debtorsPhone;
        req[types] = this.ruleForm3.actualAmt;
      }
      this.request(req);
    },
    request (data) {
      console.log(!this.payType && this.activeName === 'first' && this.ruleForm1.payType[0] !== 'cashAmt')
      console.log(!this.payType && ((this.activeName === 'first' && this.ruleForm1.payType[0] === 'cashAmt') || this.activeName === 'second' || this.activeName === 'third'))
      console.log((this.payType === 'onePay' || this.payType === 'morePay') && this.ruleForm1.payType[0] === 'cashAmt')
      console.log((this.payType === 'onePay' || this.payType === 'morePay') && this.ruleForm1.payType[0] !== 'cashAmt')
      // 单种支付除开现金以外都无需用element 验证 ， this.payType 防止在欠费支付的时候
      if (!this.payType && this.activeName === 'first' && this.ruleForm1.payType[0] !== 'cashAmt') {
        this.$api.feeDispense.changePayWay(data).then((res) => {
          this.newRecordVersion = res.recordVersion;
          // 判断是否为在线支付
          if (this.isOnlinePay) {
            this.wechatPayAmt = data.wechatPayAmt;
            this.onlinePayCall(data.id, data.wechatPayAmt);
          } else {
            this.payCallBack(() => {
              this.$message({
                message: '恭喜你，支付成功!',
                type: 'success',
              });
              this.$emit('complated', { orderId: this.createdOrderId });
              this.confirmDisable = false;
            });
          }
        }).catch(() => {
          this.confirmDisable = false;
        });
      }
      // 直接售药的接口无需传类型值 当前区分两种场景 一种是 《直接售药》 另一种是 《欠费的支付》 接口不一样
      if (!this.payType && ((this.activeName === 'first' && this.ruleForm1.payType[0] === 'cashAmt') || this.activeName === 'second' || this.activeName === 'third')) {
        this.$refs[this.activeName].validate((valid) => {
          if (valid) {
            this.$api.feeDispense.changePayWay(data).then((res) => {
              // 判断是否为在线支付
              this.newRecordVersion = res.recordVersion;
              console.log(this.isOnlinePay)
              if (this.isOnlinePay) {
                this.wechatPayAmt = data.wechatPayAmt;
                this.onlinePayCall(data.id, data.wechatPayAmt);
              } else {
                this.payCallBack(() => {
                  this.$message({
                    message: '恭喜你，支付成功!',
                    type: 'success',
                  });
                  // 触发完成事件
                  setTimeout(() => {
                    this.confirmDisable = false;
                  }, 500);
                  this.$emit('complated', { orderId: this.createdOrderId });
                });
              }
            }).catch(() => {
              this.confirmDisable = false;
            });
          } else {
            // console.log('error submit!!');
            this.confirmDisable = false;
            return false;
          }
          return false;
        });
      }
      if ((this.payType === 'onePay' || this.payType === 'morePay') && this.ruleForm1.payType[0] === 'cashAmt') {
        const req = {
          orderId: this.orderIds,
          type: this.payType === 'onePay' ? 1 : 2,
          balance: data,
        };
        this.$refs[this.activeName].validate((valid) => {
          if (valid) {
            this.$api.feeDispense.changeBalancePayWay(req).then((res) => {
              this.newRecordVersion = res.recordVersion;
              this.payCallBack(() => {
                // 触发完成事件
                this.$emit('complated', { orderId: this.createdOrderId });
                setTimeout(() => {
                  this.confirmDisable = false;
                }, 500);
                this.$message({
                  message: '恭喜你，支付成功!',
                  type: 'success',
                });
              });
            }).catch(() => {
              this.confirmDisable = false;
            });
          } else {
            this.confirmDisable = false;
            // console.log('error submit!!');
            return false;
          }
          return false;
        });
      }
      if ((this.payType === 'onePay' || this.payType === 'morePay') && this.ruleForm1.payType[0] !== 'cashAmt') {
        const req = {
          orderId: this.orderIds,
          type: this.payType === 'onePay' ? 1 : 2,
          balance: data,
        };
        this.$api.feeDispense.changeBalancePayWay(req).then((res) => {
          this.newRecordVersion = res.recordVersion;
          this.payCallBack(() => {
            // 触发完成事件
            setTimeout(() => {
              this.confirmDisable = false;
            });
            this.$emit('complated', { orderId: this.createdOrderId });
            this.$message({
              message: '恭喜你，支付成功!',
              type: 'success',
            });
          });
        }).catch(() => {
          this.confirmDisable = false;
        });
      }
    },
    // 在线支付
    onlinePayCall (orderId, actualAmt) {
      this.$api.feeDispense.orderPay({ orderId, actualAmt }).then((res) => {
        this.isAwaitPaying = true;
        this.orderNo = res.orderNo;
        this.runTime();
      });
    },
    // 支付倒计时
    runTime () {
      setTimeout(() => {
        this.awaitTime = this.awaitTime - 1;
        if (this.awaitTime !== 0 && this.isAwaitPaying) {
          this.runTime();
        } else {
          this.close();
          this.clearHisData();
          this.awaitTime = 60;
        }
      }, 1000);
    },
    // 扫码支付
    scanPay () {
      this.$api.feeDispense.scanPay({
        orderNo: this.orderNo,
        payCode: this.payCode,
      }).then(() => {
        this.$emit('complated', { orderId: this.createdOrderId });
        this.$message({
          message: '恭喜你，支付成功!',
          type: 'success',
        });
      }).catch(() => {
        this.close();
        this.$message({
          message: '支付失败请再次尝试!',
          type: 'error',
        });
      });
    },
    // 非在线支付
    payCallBack (callback) {
      const req = {
        orderId: this.orderIds || this.$route.query.id,
        acct_used_flag: this.radio
      };
      if (this.recordVersion) {
        req.recordVersion = this.newRecordVersion;
      }
      this.$api.feeDispense.offlinePayCall(req).then((res) => {
        this.createdOrderId = res;
        callback();
      }).catch(() => {
        this.confirmDisable = false;
      });
    },
    // 关闭窗口
    close () {
      this.$confirm('是否关闭支付窗口？', '提示').then(() => {
        this.$emit('close');
        this.$emit('update:visible', false);
        this.clearHisData();
        this.ruleForm2.payType = [] //关闭弹窗时清空多种支付方式
      }).catch(() => { })
    },
    clearHisData () {
      this.payCode = '';
      // this.ruleForm1.actualAmt = 0;
      // this.ruleForm2.cashAmt = 0;
      // this.ruleForm3.cashAmt = 0;
      // this.ruleForm3.debtorsName = '';
      // this.ruleForm3.debtorsPhone = '';
      this.$emit('update:debtorInfo', {
        debtorsName: '',
        debtorsPhone: '',
      });
      this.isAwaitPaying = false;
      // this.wechatPayAmt = 0;
    },
    // 获取支付类型
    getPayType () {
      this.$api.chainClinic.getPayConfig().then((res) => {
        // console.log(res, '支付类型');
        this.payTypeOptions = res.payModel.map((item) => {
          for (let it in item) {
            return {
              value: it,
              label: item[it],
            };
          };
        });
        // this.payTypeOptions = this.payTypeOptions.filter(item => item.label !== "商保支付")
        // console.log(this.payTypeOptions,'=this.payTypeOptions');
      }).then(() => {
        this.payNoInsuOptions = this.payTypeOptions.filter(item => {
          return item.value != "medicalInsurance"
        })
      })
    },
    firstFocus () {
      this.$nextTick(() => {
        // try {
        //   this.$refs['first-input'].$el.querySelector('input').focus();
        // } catch (error) {
        //   console.log(error);
        // }
      });
    },
    // 实收焦点事件清空内容
    ActualAmtHandle (attr) {
      this[attr].actualAmt = '';
    },
    firstPayHandle () {
      // this.ruleForm2.firstPay = '';
    },
    // 获取订单里面的医保药品列表
    getYbDrug () {
      // console.log(this.orderno,'订单号');
      this.$api.feeDispense.getYbDrugAPI({ orderNo: this.orderno }).then(res => {
        // console.log(res,'医保药品列表');
        this.insuDrugList = res.itemDrugList || []
        this.examList = res.itemExamList || []
      })
    },
    // 费用明细上传
    uploadDetail () {
      // this.$api.feeDispense.uploadFeeDetailAPI({
      //   orderNo:this.orderno,
      //   mdtrtId:this.mdtrtId
      // }).then(res =>{
      //   console.log(res,'费用明细上传');
      //   // if (res.data.code == 500) return this.$message({type:'error', message: res.data.message})
      //   if(res.lenght != 0){
      //     this.$message({
      //       message: '费用明细上传成功',
      //       type: 'success'
      //     })
      //     this.insuDrugList = res
      //     this.isUploadDetail = true
      //     // if (this.insuDrugList.some(item => item.feeDetailUpload != '0')) {
      //     //   this.isUploadDetail = true
      //     // }
      //   }
      // })
      const params = {
        orderNo: this.orderno,
        mdtrtId: this.mdtrtId || this.jzId || this.mdtrtIdByProps
      }
      this.$api.newInsurance.uploadFeeDetailAPI(params).then(res => {
        // console.log(res,'费用明细上传');
        if (res.data.code == 200) {
          this.$message({
            message: '费用明细上传成功',
            type: 'success'
          })
          this.getYbDrug()
          this.isUploadDetail = true
          this.active = 3
        } else {
          return this.$message({ type: 'error', message: res.data.message })
        }
      })
      this.$emit('settlementProcess')
    },
    // 费用明细上传撤销
    revokeFeeDetail (item) {
      this.$api.newInsurance.revokeFeeDetailAPI({
        orderItemDrugId: item.id
      }).then(res => {
        if (res.data.code == 500) {
          return this.$message({ type: 'error', message: res.data.message })
        } else if (res.data.code == 200) {
          this.$message({
            message: '费用明细上传已撤销',
            type: 'success'
          })
          this.getYbDrug()
        } else {
          return this.$message({ type: 'error', message: res.data.message })
        }
      })
    },
    // 门诊预结算
    preSettlement () {
      // if (!this.isUploadDetail) {
      //   return this.$message({type:'warning', message: '请先上传费用明细'})
      // }else{
      this.$api.newInsurance.preSettlementAPI({
        psn_no: this.psnNo || this.jzpsnNo || this.psnNoByProps,
        mdtrt_id: this.mdtrtId || this.jzId || this.mdtrtIdByProps,
        acct_used_flag: this.radio
      }).then(res => {
        // console.log(res,'门诊预结算');
        if (res.data.code == 500) {
          return this.$message({ type: 'error', message: res.data.message })
        } else if (res.data.code == 200) {
          this.$message({
            message: '试算成功',
            type: 'success'
          })
          const { data } = res.data
          console.log(res.data, '门诊预结算-------');
          this.medfeeSumamt = data.medfeeSumamt
          this.fundPaySumamt = data.fundPaySumamt
          this.psnPartAmt = data.psnPartAmt //个人负担总金额
          this.ruleForm2.medicalIndividual = data.acctPay //个账支出
          this.ruleForm2.medicalMutualAid = data.acctMulaidPay //个人账户共济支付金额
          this.psnCashPay = data.psnCashPay //个人现金支出
          this.ruleForm2.cardSn = data.outageRegResponse.cardSn //卡识别码
          this.ruleForm2.cardNo = data.outageRegResponse.cardNo //社会保障卡号
          if (this.firstPayName == '医保支付：') {
            this.ruleForm2.firstPay = this.fundPaySumamt //医保费用
            this.selfPay = data.psnCashPay + this.ruleForm2.notHiExpenses //个人支出
          } else if (this.payName == '医保支付：') {
            this.selfPay = this.fundPaySumamt //医保费用
            this.ruleForm2.firstPay = data.psnCashPay + this.ruleForm2.notHiExpenses //个人支出
          }
          this.innerVisible = false
        } else {
          return this.$message({ type: 'error', message: res.data.message })
        }
      })
      this.$emit('settlementProcess')
      // }
    },
    // 根据定单号查询门诊预结算基金分项信息
    getFundPaySumamt () {
      this.$api.newInsurance.getFundItemAPI({
        orderNo: this.orderno
      }).then(res => {
        // console.log(res,'根据定单号查询门诊预结算基金分项信息');
        if (res.data.code == 200 && res.data.data) {
          const { data } = res.data
          this.medfeeSumamt = data.medfeeSumamt
          this.fundPaySumamt = data.fundPaySumamt
          this.psnPartAmt = data.psnPartAmt //个人负担总金额
          this.ruleForm2.medicalIndividual = data.acctPay //个账支出
          this.ruleForm2.medicalMutualAid = data.acctMulaidPay //个人账户共济支付金额
          this.psnCashPay = data.psnCashPay //个人现金支出
          this.ruleForm2.cardNo = data.cardNo //社会保障卡号
          this.ruleForm2.cardSn = data.cardSn //卡识别码
          // 复现选择的个账标志
          if (this.ruleForm2.medicalIndividual) {
            this.radio = 1
          } else if (this.ruleForm2.medicalMutualAid) {
            this.radio = 2
          }
          if (this.firstPayName == '医保支付：') {
            this.ruleForm2.firstPay = this.fundPaySumamt
            this.selfPay = data.psnCashPay
          } else if (this.payName == '医保支付：') {
            this.ruleForm2.firstPay = data.psnCashPay
            this.selfPay = this.fundPaySumamt
          }
        }
      })
    },
    next () {
      if (this.active++ > 2) this.active = 0;
    },
    pre () {
      if (this.active-- < 2) this.active = 0;
      // if(this.active == 1 && this.active == 2){
      //     this.$api.newInsurance.settlementProcessAPI({
      //       orderNo:this.orderno
      //     }).then(res => {
      //       console.log(res,'结算流程');
      //       if (res.data.code == 200 && res.data.data != null) {
      //         this.settlementObj = res.data.data
      //       }
      //       if(res.data.code == 1100){
      //         this.prohibitFlag = true
      //       }
      //     })
      // }
    },
    // 上传就诊信息
    uploadVisitsInfo () {
      // console.log(this.visitsInfoUploadForm,'就诊信息');
      this.$refs.visitsInfoUploadForm.validate((valid) => {
        if (valid) {
          const params = {
            ...this.visitsInfoUploadForm,
            orderNo: this.orderno
          }
          this.$api.newInsurance.uploadVisitInfoAPI(params).then(res => {
            // console.log(res,'上传就诊信息');
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: "上传成功",
              });
              this.active = 2
              this.uploadjzInfoFlag = true
              this.$refs.visitsInfoUploadForm.clearValidate();
            } else {
              this.$message({ type: "error", message: res.data.message });
            }
          })
          this.$emit('settlementProcess')
        }
      })

    },
    uploadRegisterInfo () {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          const params = {
            ...this.registerForm,
            orderNo: this.orderno
          }
          // console.log(params,'params');
          this.$api.newInsurance.registerNoInsuAPI(params).then((res) => {
            // console.log(res, "挂号信息");
            if (res.data.code == 200 && res.data.data != null) {
              this.$message({
                type: "success",
                message: "挂号成功",
              });
              this.active = 1
              this.jzId = res.data.data.mdtrtId
              this.jzpsnNo = res.data.data.psnNo
              this.$refs.registerForm.clearValidate();
            } else {
              this.$message({ type: "error", message: res.data.message });
            }
            this.$emit('settlementProcess')
          });
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    // ---------------------挂号迁移过来的---------------------
    selectRadio (val) {
      try {
        if (val == "2") {
          this.form1.mdtrt_cert_type = "0" + val;
          this.getIdCode();
        } else if (val == "3") {
          this.form1.mdtrt_cert_type = "0" + val;
          this.form1.psn_cert_type = "90";
          this.getSbCode();
        } else if (val == "1") {
          this.form1.mdtrt_cert_type = "0" + val;
          if (this.isElectPay) {
            // 结算
            this.getElectronicVoucher('01301');
          } else {
            // 挂号
            this.getElectronicVoucher('01101');
          }
        }
      } catch (error) {
        console.log('error: ', error);
        this.readType = 0
      }
      console.log('val: ', val);

      // console.log(this.form1,'切换选择');
    },
    async initReadCard () {
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const params = {
        url: fixMedIns.apiUrl,
        User: fixMedIns.useArea,
      };
      await this.$api.newInsurance.initReadCardAPI(params)
    },
    // 读取身份证号
    async getIdCode () {
      await this.initReadCard();
      this.$api.newInsurance.getCardNoAPI().then((res) => {
        if (res.data.code == 0) {
          this.readType = 0
          this.$message({
            type: "success",
            message: "读取身份证号成功",
          });
          console.log(res, "获取身份证号");
          const { model } = res.data;
          this.form1.mdtrt_cert_no = model.cardNo;
          this.form1.psn_name = model.name;
          if (this.form1.mdtrt_cert_no) {
            this.readVisible = false;
            // 对象添加
            let formData = {
              ...this.form1,
            }
            this.getInfo(formData);
          }
        } else {
          this.readType = 0
          this.$message({
            type: "error",
            message: "读取身份证号失败，请检查是否放置身份证",
          });
        }
      });
    },
    // 读取社保卡号
    async getSbCode () {
      await this.initReadCard();
      this.$api.newInsurance.getSocialCardNoAPI().then((res) => {
        if (res.data.code == 0) {
          this.readType = 0
          this.$message({
            type: "success",
            message: "读取社保卡号成功",
          });
          // console.log(res, "获取社保卡号");
          const { model } = res.data;
          this.form1.mdtrt_cert_no = model.cardNo;
          this.form1.card_sn = model.identificationNo;
          this.form1.certno = model.shbzhmSocialSecurityNo;
          this.form1.psn_name = model.name;
          this.form1.areaNo = model.areaNo;
          this.registerForm.areaNo = model.areaNo;
          this.pCardInfo.card_sn = model.identificationNo
          this.pCardInfo.card_no = model.cardNo
          if (this.form1.mdtrt_cert_no) {
            this.readVisible = false;
            let formData = {
              ...this.form1,
            }
            this.getInfo(formData);
          }
        } else {
          this.readType = 0
          this.$message({
            type: "error",
            message: res.data.message || "读取社保卡号失败",
          });
        }
      });
    },
    // 电子凭证
    getElectronicVoucher (businessType) {
      const { fixMedIns } = Store.get("vuex").global.countInfo
      const { countInfo } = Store.get("vuex").global
      const query = {
        data: {
          // businessType:'01101',
          businessType: businessType,
          deviceType: '',
          officeId: '32760',
          officeName: '消化内科',
          operatorId: countInfo.doctorId,
          operatorName: countInfo.doctorName,
          orgId: fixMedIns.fixmedinsCode
        },
        orgId: fixMedIns.fixmedinsCode,
        transType: 'ec.query'
      }
      const params = {
        url: fixMedIns.tradeUrl,
        data: JSON.stringify(query),
      };
      // console.log(params, "电子凭证获取信息");
      this.$api.newInsurance.getElectronicVoucherAPI(params).then((res) => {
        console.log(res, "读取电子凭证");
        if (this.isElectPay) {
          // 结算
          const params2 = {
            extData: JSON.stringify(res)
          }
          this.$api.newInsurance.eVoucherPayAPI(params2).then(res => {
            console.log(res, '上传电子凭证返回的数据');
            this.readVisible = false
          })
        } else {
          // 挂号
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "电子凭证获取信息成功",
            });
            const { data } = res.data;
            this.form1.mdtrt_cert_no = data.ecToken;
            this.form1.psn_cert_type = data.idType;
            this.form1.certno = data.idNo;
            this.form1.psn_name = data.userName;
            this.form1.areaNo = data.insuOrg;
            this.registerForm.mdtrt_cert_no = data.ecToken;//挂号时要传ectoken
            this.registerForm.areaNo = data.insuOrg;
            // console.log(this.form1,'form1')
            if (this.form1.mdtrt_cert_no) {
              this.readVisible = false;
              let formData = {
                ...this.form1,
              }
              this.getInfo(formData);
            }
          } else {
            this.readType = 0
            this.$message({
              type: "error",
              message: "电子凭证获取信息失败",
            });
          }
        }
      });
    },
    // // 社保卡交易
    // async SbTransactions(){
    //   const total1 = Number(this.total).toFixed(2)
    //   const total2 = (ruleForm2.medicalIndividual + fundPaySumamt).toFixed(2)
    //   const params = {
    //     strpCardInfo: this.pCardInfo.card_sn + '|' + this.pCardInfo.card_sn + '|',
    //     strpPayInfo: total1 + '|' + total2 + '|' + getFormatDate1() + '|'
    //   }
    //   await this.$api.newInsurance.socialCardTransactions(params)
    // },
    getInfoTest () {
      const params = {
        mdtrt_cert_type: "02",
        // mdtrt_cert_no:'43038119990617234X'//李湘钰
        // mdtrt_cert_no:'43038119990617234X',
        // certno:'43038119990617234X'
        mdtrt_cert_no: '430621198410142759',
        certno: '430621198410142759'
        // mdtrt_cert_no:'34012119811225581X'
      };
      this.getInfo(params);
    },
    getInfo (obj) {
      this.$api.newInsurance.getPatientInfoAPI(obj).then((res) => {
        // console.log(res, "人员信息");
        if (res.data.code == 200) {
          this.$message({
            message: "获取人员信息成功",
            type: "success",
          });
          const { data } = res.data;
          this.registerForm.age = Math.floor(data.age)
          this.registerForm.bir = data.brdy.substring(0, 10);
          this.registerForm.naty = data.naty;
          this.registerForm.gender = data.gend;
          this.registerForm.psn_no = data.psnNo;
          this.registerForm.psn_name = data.psnName;
          this.registerForm.mdtrt_cert_type = data.mdtrtCertType;
          this.registerForm.mdtrt_cert_no = data.mdtrtCertNo;
          this.registerForm.psn_cert_type = data.psnCertType;
          this.registerForm.begntime = getFormatDate2();
          this.registerForm.certno = data.certno;
          this.registerForm.psn_type = "11";
          this.registerForm.phone = data.phone;
          this.insuTypeList = data.personnelInsuinfoList;
          // 默认展示职工基本医疗保险
          if (this.insuTypeList.some((item) => item.insutype == "310")) {
            this.registerForm.insutype = "310";
            this.insutypeLabel = '职工基本医疗保险'
          } else {
            this.registerForm.insutype = this.insuTypeList[0].insutype;
            this.insutypeLabel = this.insuTypeList[0].insutypeName
          }
          // 处理慢特病数据
          if (data.chronicIdiopathyList != null) {
            this.opspDiseasesList = data.chronicIdiopathyList;
            const arr = [];
            data.chronicIdiopathyList.forEach((item) => {
              arr.push(item.opsp_dise_name);
            });
            // console.log(arr, "arr");
            this.registerForm.chronic = arr.join(",");
            // console.log(this.registerForm.chronic, "this.registerForm.chronic");
          } else {
            this.registerForm.chronic = "无";
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    // 获取科室列表
    getDepartment () {
      this.$api.clinicManagement.getListLaboratory().then((res) => {
        // console.log("诊所科室列表", res);
        this.laboratoryList = res;
        this.insuDeptList = res.filter((item) => item.hiHiName.length > 0);
        // console.log("诊所医保科室列表",this.insuDeptList);
        // this.getDoctor();
      });
    },
    // 获取科室对应的人员列表
    selectDept (val) {
      // console.log(val, "科室id");
      if (val) {
        this.query.laboratoryId = val;
      }
      const selected = this.insuDeptList.find(
        (item) => item.laboratoryId == val
      );
      // console.log(selected,'selected');
      this.registerForm.dept_code = selected.hiHiCode;
      this.registerForm.dept_name = selected.hiHiName;
      this.registerForm.caty = selected.hiHiCode;
      // console.log(this.form,'form');
      this.$api.clinicManagement
        .getDoctorListByLaboratoryAPI(this.query)
        .then((res) => {
          // console.log(res, "科室人员");
          this.doctorList = res;
        });
    },
    selectDoctor (val) {
      // console.log(val,'医生id');
      const selected = this.doctorList.find((item) => item.doctorId == val);
      // console.log(selected,'selected');
      this.registerForm.dr_name = selected.realName;
      this.registerForm.atddr_no = selected.hiPhysicianCode;
      // console.log(this.registerForm, "registerForm");
      this.getSchedule(val);
    },
    getSchedule (value) {
      this.$api.workbench.getDoctorSchedulingAPI({
        doctorId: value,
        workDay: setToday(),
      }).then((res) => {
        // console.log(res, "医生排班列表");
        this.schedulingList = res;
      });
    },
    selectTime (val) {
      this.registerForm.settingExtendId = val;
      const selected = this.schedulingList.find((item) => item.scheduleId == val);
      this.scheduleString = selected.startTime.substring(0, 16) + '~' + selected.endTime.substring(11, 16)
    },
    selectInsuType (val) {
      this.insuTypeList.forEach(item => {
        this.insutypeLabel = item.insutype == val ? item.insutypeName : ''
      })
    },
    // 非管理员挂号信息回填
    recurrentInfo () {
      // console.log(this.countInfo,'this.countInfo');
      // console.log(this.isAdmin,'this.isAdmin');
      // console.log(this.registerFlag,'this.registerFlag');
      if (!this.isAdmin && this.registerFlag) {
        // 展示
        // this.registerForm.laboratoryName = this.countInfo.laboratoryName
        // this.registerForm.doctorName = this.countInfo.doctorName
        // console.log(this.countInfo,'this.countInfo')
        this.$set(this.registerForm, 'laboratoryName', this.countInfo.laboratoryName)
        this.$set(this.registerForm, 'doctorName', this.countInfo.doctorName)
        // 传参
        this.registerForm.dept_code = this.countInfo.hiHiCode
        this.registerForm.dept_name = this.countInfo.hiHiName
        this.registerForm.caty = this.countInfo.hiHiCode
        this.registerForm.atddr_no = this.countInfo.hiMedicineCode || this.countInfo.hiPhysicianCode
        this.registerForm.dr_name = this.countInfo.doctorName
        this.registerForm.doctorId = this.countInfo.doctorId
        this.registerForm.laboratoryId = this.countInfo.laboratoryId
        // 获取医生排班信息
        this.getSchedule(this.countInfo.doctorId)
      }
      // 必验项调整
      // if (this.isAdmin) {
      //   // 管理员
      //   this.registerRules.dept_name[0].required = false
      //   this.registerRules.dr_name[0].required = false
      // }else{
      //   this.registerRules.laboratoryId[0].required = false
      //   this.registerRules.doctorId[0].required = false
      // }
    },
    // ----------------------------------

    // ----------------门诊病历迁移过来的----------------
    selectMedType (val) {
      // 医疗类别为慢特病门诊时，病种为必填项 11为普通门诊，14为慢特病门诊
      if (val == '14') {
        this.visitsInfoUploadRules.dise_codg[0].required = true
      } else {
        this.visitsInfoUploadRules.dise_codg[0].required = false
      }
    },
    setDiseaseSel (e) {
      // console.log(e,'病种编码');
      this.diseaseList.forEach(item => {
        if (item.code == e) {
          this.visitsInfoUploadForm.dise_name = item.name
        }
      })
      // console.log(this.visitsInfoUploadForm.dise_name,'名称');
    },
    querySearchDisease (query) {
      // console.log(query,'query');
      if (query != '') {
        setTimeout(() => {
          const params = {
            diseaseType: '11',
            diseaseName: query
          }
          this.$api.newInsurance.getDiseaseTypeAPI(params).then(res => {
            // console.log(res,'1111');
            if (res.data.code == 200 && res.data.data != null) {
              this.diseaseList = res.data.data
            }
          })
        }, 200);
      } else {
        this.diseaseList = []
      }
    },
    querySearchDiag (query) {
      // console.log(query,'query');
      if (query != '') {
        setTimeout(() => {
          const params = {
            diagType: this.visitsInfoUploadForm.diag_type,
            diagName: query
          }
          this.$api.newInsurance.getDiagnosisByTypeAPI(params).then(res => {
            // console.log(res,'诊断');
            if (res.data.code == 200 && res.data.data != null) {
              this.diagTypeList = res.data.data
            }
          })
        }, 200);
      } else {
        this.diagTypeList = []
      }
    },
    // ----------------------------------
    finish () {
      this.innerVisible = false
      if (this.firstPayName == '医保支付：') {
        this.ruleForm2.firstPay = this.fundPaySumamt //医保费用
        this.selfPay = this.psnCashPay + this.ruleForm2.notHiExpenses //个人支出
      } else if (this.payName == '医保支付：') {
        this.selfPay = this.fundPaySumamt //医保费用
        this.ruleForm2.firstPay = this.psnCashPay + this.ruleForm2.notHiExpenses //个人支出
      }
    },
    // 处理默认支付方式 欠费补款时默认选中单种支付
    changeActiveName () {
      this.activeName = 'first';
    },
    // 获取会员余额
    getMemberMoney() {
      this.$api.member.getMemberMoney({id: this.userOrderIds }).then(res => {
        if (Object.keys(res || {}).length <= 0) {
          this.isShowMemberMoney = false;
        } else {
          this.isShowMemberMoney = true;
          this.memberMoney = res.balance;
        }
      })
    },
    // 采集追溯码
    openTDialog() {
      this.$refs.traceabilityCodeRef.againOpenDialog(this.traceabilityList)
    },
    async getTraceabilityList() {
      // 先看有没有开启医保上报
      let result1 = await this.$api.clinicManagement.getHospitalConfig({ configType:22, })
      // 再看有没有说追溯码必填
      let result2 = await this.$api.clinicManagement.getHospitalConfig({ configType:24, })
      // 再看看显不显示采集按钮
      let result3 = await this.$api.clinicManagement.getHospitalConfig({ configType:23, })
      this.invRequired = result1.invRequired || 0;
      this.traceCodeRequired = result2.traceCodeRequired || 0;
      this.isOpenTraceCode = result3.isOpenTraceCode || 0;
      if (this.isOpenTraceCode == 1) {
        this.$api.traceabilityCode.getTraceabilityCode(this.orderno).then((res) => {
          if (res.orderItemDiagnosisDetailList && res.orderItemDiagnosisDetailList.length) {
            for (const item of res.orderItemDiagnosisDetailList) {
              item.drugName = item.hiProjectName
              item.dosage = item.number
              item.saleUnit = item.unit
            }
          }
          console.log(res, '追溯码列表')
          this.traceabilityList = res
        });
      }
    },
  },
  mounted () {
    this.getPayType();
    this.getDepartment();
    // this.recurrentInfo()
  },
  watch: {
    // 患者订单id
    userOrderId(val) {
      this.userOrderIds = val
      this.getMemberMoney()
    },
    // 监听code 状态有没有输入
    payCode (val) {
      if (val.length === 18) this.scanPay();
    },
    amount: {
      immediate: true,
      handler (val) {
        this.total = val;
        this.ruleForm1.actualAmt = val;
        this.ruleForm2.firstPay = val;
        this.ruleForm2.cashAmt = val;
        this.ruleForm3.actualAmt = val;
        this.firstFocus();
      },
    },
    debtorInfo: {
      immediate: true,
      handler (val) {
        // 传入欠费人的信息
        this.ruleForm3.debtorsName = val.name;
        this.ruleForm3.debtorsPhone = val.phone;
        this.isNameDisabled = Boolean(this.ruleForm3.debtorsName);
        this.isPhoneDisabled = Boolean(this.ruleForm3.debtorsPhone);
      },
      deep: true,
    },
    orderId: {
      immediate: true,
      handler (val) {
        this.orderIds = val;
      },
    },
    'ruleForm1.actualAmt': function (val) {
      if (!val || isNaN(Number(val))) {
        this.ruleForm1.changeAmt = '0.00';
        return;
      }
      this.ruleForm1.changeAmt = BN(val).minus(this.total).toFixed(2);
    },
    isHiReg: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal) {
          this.ruleForm2.payType.push('medicalInsurance')
          this.ruleForm2.payType = [...new Set(this.ruleForm2.payType)]
        }
      }
    },
    visible(v) {
      // 监听调获取追溯码的接口
      if (v) {
        this.getTraceabilityList()
      }
    }
  },
  computed: {
    isOnlinePay () {
      if (this.activeName === 'first') {
        return this.ruleForm1.payType.some(item => item === 'wechatPayAmt');
      }
      if (this.activeName === 'second') {
        return this.ruleForm2.payType.some(item => item === 'wechatPayAmt');
      }
      if (this.activeName === 'third') {
        return this.ruleForm3.payType.some(item => item === 'wechatPayAmt');
      }
      return '';
    },
    // 判断当前是不是微信小程序付款
    isWechatMini () {
      if (this.activeName === 'first') {
        return this.ruleForm1.payType.some(item => item === 'wechatAppsAmt');
      }
      if (this.activeName === 'second') {
        return this.ruleForm2.payType.some(item => item === 'wechatAppsAmt');
      }
      if (this.activeName === 'third') {
        return this.ruleForm3.payType.some(item => item === 'wechatAppsAmt');
      }
      return false;
    },
    isCash () {
      return this.ruleForm1.payType[0] === 'cashAmt' || this.ruleForm1.payType[0] === 'memberAmt' || this.payType === 'onePay';
    },
    // 有没有填写多种支付
    hasPayType () {
      return this.ruleForm2.payType.length >= 2;
    },
    payName () {
      const item = this.payTypeOptions.find(it => (it.value === this.ruleForm2.payType[1]));
      // 初始化的时候没有label的值会报错
      return item ? `${item.label}：` : '';
    },
    firstPayName () {
      const item = this.payTypeOptions.find(it => (it.value === this.ruleForm2.payType[0]));
      // 初始化的时候没有label的值会报错
      return item ? `${item.label}：` : '';
    },
    otherAmt () {
      const price = Number(this.ruleForm2.firstPay);
      if (!price || isNaN(price)) {
        return this.amount;
      }
      if (price >= this.amount) return '0.00';
      return BN(this.amount).minus(price).toFixed(2);
    },
    debtAmt () {
      const price = Number(this.ruleForm3.actualAmt);
      if (!price || isNaN(price)) return this.amount;
      if (price >= this.amount) return '0.00';
      return BN(this.amount).minus(price).toFixed(2);
    },
    // 明细是否全部上传成功
    hasUploadDetail () {
      // every检测空数组返回true，所以要进行判断
      let flag1 = false
      if (this.insuDrugList && this.insuDrugList.length) {
        flag1 = this.insuDrugList.every(item => item.hiUploadStatus == '1') //中西成药
      }
      let flag2 = false
      if (this.examList && this.examList.length) {
        flag2 = this.examList.every(item => item.hiUploadStatus == '1') //检查项目
      }
      return flag1 || flag2
    },
    // 是否为医保流程
    isInsuProcess () {
      let flag = false
      if (this.settlementObj.processType && this.settlementObj.processType == 1) {
        flag = true
      }
      return flag
    },
    // 是否进行预结算
    isPreSettlement () {
      let flag = false
      if (this.settlementObj.orderPreSettlement && Object.keys(this.settlementObj.orderPreSettlement).length > 0) {
        flag = true
      }
      return flag
    },
    isSbCardPay () {
      let flag = false
      if (this.settlementObj.orderPreSettlement && this.settlementObj.orderPreSettlement.mdtrtCertType == '03') {
        flag = true
      }
      return flag
    },
    // 是否补充挂号流程
    isSupplementRegister () {
      let flag = false
      if (this.settlementObj.processType && this.settlementObj.processType == 2 && this.settlementObj.registeredType == 1) {
        flag = true
      }
      return flag
    },
    // 是否有就诊ID
    hasJzId () {
      return Boolean(this.mdtrtId || this.jzId || this.mdtrtIdByProps)
    },
    countInfo () {
      return Store.get("vuex").global.countInfo
    },
    isAdmin () {
      // 1 管理员 0 普通用户
      const { isAdmin } = this.countInfo
      return isAdmin
    },
    registerFlag () {
      // 有医生/药师编码和科室编码则可以挂号
      let flag = false
      if (!this.isAdmin) {
        flag = this.countInfo.hiHiCode && (this.countInfo.hiMedicineCode || this.countInfo.hiPhysicianCode)
      }
      return flag
    },
    isHiSuccess () {
      // return this.$store.state.global.isHiSuccess
      const flag = this.$store.state.global.isHiSuccess
      return flag
    },
    cityName () {
      const { countInfo } = Store.get("vuex").global
      return countInfo.city ? countInfo.city : ''
    },
    // 采集的追溯码的数量
    traceabilityCodeNum() {
      return this.keyList.reduce((prev, item) => {
        let numRes = this.traceabilityList[item].reduce((p, e) => {
          if ((e.hiProjectCode || e.hiMedListCodg) && e.hiPayType != 3) {
            let tracCodeList = e.tracCode ? e.tracCode.split(',') : []
            let num = tracCodeList.length
            return p += num
          } else {
            return p
          }
        }, 0)
        return prev += numRes
      }, 0)
    },
    // 采集追溯码的药品的数量
    traceabilityDrugNum() {
      return this.keyList.reduce((prev, item) => {
        let numRes = this.traceabilityList[item].reduce((p, e) => {
          if ((e.hiProjectCode || e.hiMedListCodg) && e.hiPayType != 3) {
            return p += Number(e.dosage)
          } else {
            return p
          }
        }, 0)
        return prev += numRes
      }, 0)
    }
  },
};
